import { z } from 'zod';

const zRetailOrg = z.object({
  id: z.number(),
  name: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const zRetailOrgsResponse = z.object({
  organizations: z.array(zRetailOrg),
});

export type RetailOrg = z.infer<typeof zRetailOrg>;
export type RetailOrgsResponse = z.infer<typeof zRetailOrgsResponse>;
